document.addEventListener('DOMContentLoaded', () => {
    const popup = document.querySelector('[data-alcohol-popup]');
    if (!popup) return;

    if (localStorage.getItem('alcoholConfirmed') === 'true') return;

    popup.hidden = false;
    document.body.classList.add('no-scroll');

    const allowBtn = popup.querySelector('[data-allow]');
    const denyBtn = popup.querySelector('[data-deny]');
    const overlay = popup.querySelector('.alcohol-popup__overlay');
    const redirectUrl = popup.dataset.redirectUrl || window.location.origin;

    const closePopup = () => {
        popup.remove();
        document.body.classList.remove('no-scroll');
    };

    allowBtn.addEventListener('click', () => {
        localStorage.setItem('alcoholConfirmed', 'true');
        closePopup();
    });

    denyBtn.addEventListener('click', () => {
        window.location.href = redirectUrl;
    });

    overlay.addEventListener('click', closePopup);
});
